<template>
  <navbar id="headerNav" style="height: 120px">
    <div id="header" class="header">
      <div class="left" >
        <img src="/static/img/cei_logo.png" />
      </div>
      <div class="center" v-if="isShow">
        <img src="/static/img/cei_tp.png" />
      </div>
      <div class="right">
        <div class="list">
          <div class="defu">
            <div class="user6"></div>
            欢迎您，
          </div>
          <div id="anvlfteb" class="anvlfteb">
            <ul>
              <li class="drop-down">
                <div>
                  <a href="javascript:void(0);" id="userName"
                    ><span>{{ username }}</span
                    ><i class="arrow"></i
                  ></a>
                </div>
                <ul class="drop-down-content">
                  <li v-for="userInfo in userInfoList">
                    <a @click="loginOut(userInfo)">{{ userInfo.vlname }}</a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </navbar>
</template>

<script>
import navbar from "./Navbar";
import Cookies from "js-cookie";
import { getCeiVlst,ceiLoginOut } from "../api/home";

export default {
  name: "CeiAppHeader",
  data() {
    return {
      username: Cookies.get("SET_NAME"),
      userInfoList: [],
      isShow:true,
    };
  },
  created() {
    this.init();
    window.addEventListener("resize", this.changeHeader);
    this.changeHeader();
  },
  components: {
    navbar,
  },
  methods: {
    
    changeHeader() {       
        let width;
      width=document.getElementById("headerNav").offsetWidth;
 
      if(width<1500){
         this.isShow=false;
      }else{
          this.isShow=true;
      }
    },
    init() {
      document.title = "中经网企业大数据平台";
      let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = "/static/img/cei.ico";
      document.getElementsByTagName('head')[0].appendChild(link);
      getCeiVlst()
        .then((rep) => {
          this.userInfoList = rep.data.data.vlst;
          this.username=rep.data.data.vname;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loginOut(param){
      if(param.vlname == "安全退出"){
        console.log("===============");
        ceiLoginOut().then((rep) => {
           window.open(param.vlurl,"_self");
        }).catch((err) => {
          window.open(param.vlurl,"_self");
        });
      }else {
        window.open(param.vlurl,"_self");
      }
    }
  },
};
</script>
<style scoped>
.header {
  background: url("/static/img/header/header_bj.png") no-repeat center top;
  background-size: cover;
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: space-between;
  min-width: 800px;
}

.header div {
  display: inline-block;
}

.left {
  /* float: left; */
  height: 100%;
  width: 535px;
  margin: 20px 20px;
}

.center {
  /* float: left; */
  margin: 15px 130px;
}

.right {
  width: 300px;
  height: 100%;
  /* float: right; */
}

.list {
  margin-top: 50px;
}

.user6 {
  background-image: url("/static/img/avatars/ry.png");
  width: 14px;
  height: 16px;
  margin-right: 5px;
}

.defu {
  color: #fff;
  float: left;
}

.anvlfteb {
  position: relative;
  color: #fff;
}

#userName {
  color: #fff;
}

#userName span {
  padding-left: 5px;
  float: left;
}

.drop-down {
  color: #fff;
}

.drop-down .arrow {
  float: left;
  background-image: url("/static/img/zk.png");
  width: 6px;
  height: 4px;
  margin-top: 7px;
  margin-left: 5px;
  margin-right: 5px;
}
.drop-down:hover .arrow {
  background-image: url("/static/img/sq_h.png");
}
.drop-down-content li {
  color: #fff5e6;
  background-color: #fff;
  text-align: center;
  padding-top: 2px;
}
.drop-down-content {
  padding: 0;
  display: none;
  /*position: absolute;*/
}

.drop-down:hover #userName {
  color: #999;
}

.drop-down-content:hover li:hover {
  background-color: #ddd;
}
.drop-down:hover .drop-down-content {
  display: block;
  background-color: #947d7d;
}
.drop-down:hover .drop-down-content a {
  color: #666;
}

.drop-down:hover {
  border: 1px solid #ccc;
  background-color: #fff;
  color: #000;
}
</style>




// WEBPACK FOOTER //
// CeiAppHeader.vue?a905b1e8